import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import Personalization from './Personalization';

export default function Blog() {
  return (
    <>
        <Navbar />
        <Personalization />
        <Footer />
        <Copyright />
    </>
  )
}